import React from 'react';
import { useTranslation } from 'react-i18next';

function Vision() {
  const { t } = useTranslation();

  return (
    <section className="vision-section" id="vision">
      <h3>{t('vision.title')}</h3>
      <p className="vision-description">{t('vision.description')}</p>
      <ul className="vision-list">
        {t('vision.points', { returnObjects: true }).map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </section>
  );
}

export default Vision;

